import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import {env_vars} from './load-env';

const SUPPORTED_LANGS = document.body.getAttribute('data-supported-lang')?.split(',');
const LANG_EVENT_KEY = 'brreg:lang-change';

export const initI18N = () => i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: document.documentElement.getAttribute('lang'),
    supportedLngs: SUPPORTED_LANGS,
    fallbackLng: 'nb',
    detection: {
      order: ['htmlTag', 'path', 'cookie'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: `${env_vars.EXPRESS_CONTEXT_PATH}/assets/locales/{{lng}}/{{ns}}.json`,
    },
    debug: false,
    ns: ['felles', 'betalt', 'basicAuthLogin', 'lisensRegistrering', 'titel', 'serverError', 'warning'],
    defaultNS: 'lisensregistrering',
    keySeparator: false,
    interpolation: {
      escapeValue: false, // Not needed for react!!
      formatSeparator: ','
    },
    react: {
      wait: true,
      useSuspense: false
    },
  }, () => {
    window.addEventListener(LANG_EVENT_KEY, (event) => {
      const oldPath = window.location.pathname.split('/');
      const langInPath = oldPath.find(p => ['nb', 'nn', 'en'].includes(p));
      let newPath;
      if (langInPath) {
        newPath = oldPath.map((p => p === langInPath ? event.language : p));
      } else {
        newPath = [event.language, ...oldPath];
      }
      window.location.href = '/' + newPath.filter(p => p).join('/');
    });
  }).then();

export default i18n;

